import { Card, CardContent } from "@/components/ui/card";
import { LoadingSpinner } from "@/components/ui/spinner";

export default function LoadingScreen() {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <Card className="my-10 w-96">
        <CardContent>

          <div className="flex flex-col gap-5 justify-center">

            <div className="flex flex-col justify-center items-center">
              <div className="flex items-center bg-black p-2 rounded-md">
                <img
                  className="w-auto h-5"
                  src="EssilorLuxotticaWhite.svg" // Replace with your logo path
                  alt="App Logo"
                  width={120} // Adjust size as needed
                  height={60} // Adjust size as needed
                />
              </div>
              <div className="text-normal font-Avenir text-black flex items-center">
                <span className="inline-flex mr-3">
                  <span className="h-3 w-3 bg-black rounded-full"></span>
                  <span className="h-3 w-3 bg-black rounded-full ml-1"></span>
                </span>
                MONTHLY CLOSING
              </div>

            </div>
            <div className="text-center flex">
              <LoadingSpinner />
              Loading...
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}